import * as types from 'constants/dispositivosActionTypes';
import * as services from 'services/devices.service';

export const getAllDevices = () => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.fetchDevices();
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const getDevicesUnassigned = () => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.fetchDevicesUnassigned();
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const getDevicesAssigned = () => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.fetchDevicesAssigned();
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const saveDevices = (data) => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.saveDevices(data);
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const saveAssignDevice = (data) => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.saveAssignDevice(data);
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const deleteAssignment = (data) => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.deleteAssignment(data);
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const deleteDevice = (data) => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.deleteDevice(data);
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const editAssignDevice = (data) => async (dispatch) => {
  dispatch({ type: types.GET_DISPOSITIVOS_LOADING });
  try {
    const response = await services.editAssignDevice(data);
    dispatch({ type: types.GET_DISPOSITIVOS_SUCCESS, response });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_DISPOSITIVOS_FAILURE, error });
    return { success: false, response: error };
  }
};
